"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTopNav = exports.makeMyClasses = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        padding: 4,
        width: 'fit-content',
    },
    button: {
        borderRadius: 16,
        minWidth: 94,
    },
});
exports.makeMyClasses = makeMyClasses;
function AppTopNav(props) {
    const { selected, navs = [] } = props;
    const myCss = (0, web_css_1.default)(exports.makeMyClasses);
    const { goTo } = (0, useNav_1.default)();
    const handleClick = (0, useCallforward_1.default)(nav => () => {
        goTo(nav.link.replace(':viewId', 'default'));
    }, [goTo]);
    return (0, react_1.useMemo)(() => {
        if (!(navs === null || navs === void 0 ? void 0 : navs.length))
            return null;
        return (react_1.default.createElement(Horizontal_1.default, { gutter: true, classes: { root: myCss.root } }, navs.map((nav, idx) => {
            const isSelected = nav.link === (selected === null || selected === void 0 ? void 0 : selected.link);
            const isFirst = idx === 0;
            const isLast = idx === (navs === null || navs === void 0 ? void 0 : navs.length) - 1;
            return (react_1.default.createElement(Button_1.default, { key: 'nav' + idx, classes: {
                    root: (0, web_css_1.cx)(myCss.button, isSelected ? 'selected' : undefined, isFirst ? 'first' : undefined, isLast ? 'last' : undefined),
                }, background: isSelected ? false : true, color: isSelected ? lib_palette_1.default.primary : lib_palette_1.default.GreyBlue, label: nav.label(), onClick: handleClick(nav) }));
        })));
    }, [navs, myCss, selected, handleClick]);
}
exports.AppTopNav = AppTopNav;
exports.default = AppTopNav;
